import { all } from 'typed-redux-saga';

import {
  watchAskQuestion,
  watchDeleteConversation,
  watchEditConversationName,
  watchEditQuestion,
  watchGetConversations,
  watchGetDetailConversation,
} from './conversation';
import {
  watchDeleteFiles,
  watchGetFiles,
  watchGetReadToken as watchGetReadTokenDocument,
} from './document';
import { watchGetListNotification, watchPutMarkAsReadNotification } from './home';
import {
  watchGetConnections,
  watchGetDocumentsByProject,
  watchGetProjects,
  watchSynchDocumentRequest,
} from './synchronization';
import {
  watchAskQuestion as watchAskQuestionTask,
  watchDeleteTask,
  watchEditQuestion as watchEditQuestionTask,
  watchEditTaskName,
  watchGetDetailTask,
  watchGetTasks,
  watchUpdateFileStatus,
} from './task';
import {
  watchDeleteTranslationTask,
  watchEditTranslationTaskName,
  watchGetDetailTranslationTask,
  watchGetLanguageData,
  watchGetTranslationTasks,
  watchRequestDownloadAllTranslatedFiles,
  watchRequestTranslation,
  watchUpdateTranslatedFileStatus,
  watchUpdateTranslationFileStatus,
} from './translation';
import {
  watchCompleteUpload,
  watchCompleteUploadFile,
  watchGetUploadUrl,
  watchStartUpload,
  watchUploadFile,
} from './upload';
import {
  watchChangePassword,
  watchCreateUser,
  watchDeleteUser,
  watchEditUser,
  watchFetchListUser,
} from './userManage';

export default function* rootSage() {
  yield* all([
    /* user */
    watchCreateUser(),
    watchDeleteUser(),
    watchFetchListUser(),
    watchChangePassword(),
    watchEditUser(),

    /* upload */
    watchStartUpload(),
    watchUploadFile(),
    watchGetUploadUrl(),
    watchCompleteUpload(),
    watchCompleteUploadFile(),

    /* conversations */
    watchGetConversations(),
    watchGetDetailConversation(),
    watchAskQuestion(),
    watchEditConversationName(),
    watchDeleteConversation(),
    watchEditQuestion(),

    /* tasks */
    watchGetTasks(),
    watchGetDetailTask(),
    watchEditTaskName(),
    watchAskQuestionTask(),
    watchDeleteTask(),
    watchUpdateFileStatus(),
    watchEditQuestionTask(),

    /** translation tasks */
    watchGetTranslationTasks(),
    watchGetDetailTranslationTask(),
    watchEditTranslationTaskName(),
    watchDeleteTranslationTask(),
    watchGetLanguageData(),
    watchUpdateTranslationFileStatus(),
    watchRequestTranslation(),
    watchUpdateTranslatedFileStatus(),
    watchRequestDownloadAllTranslatedFiles(),

    /* notification */
    watchGetListNotification(),
    watchPutMarkAsReadNotification(),

    /* document */
    watchGetFiles(),
    watchDeleteFiles(),
    watchGetReadTokenDocument(),

    /* synchronization */
    watchGetConnections(),
    watchGetProjects(),
    watchGetDocumentsByProject(),
    watchSynchDocumentRequest(),
  ]);
}
